<template>
  <div class="app-header">
    <nav
      class="navbar navbar-light navbar-expand-lg p-0 border-0 shadow header-normal"
      style="background:#0C0C0CF5"
    >
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <span>
            <img :src="starlogo" width="30px" />
          </span>
          SILVER STAR AUTO
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse container-fluid d-none d-lg-block"
          id="navbarSupportedContent"
        >
          <ul class="nav navbar-nav ml-md-auto text-uppercase">
            <li class="nav-item py-md-3" @click="brand" style="cursor:pointer">
              <span class="nav-link">BRANDS</span>
            </li>
            <li class="nav-item py-md-3">
              <router-link class="nav-link" to="/aftersales" exact>AFTER-SALES</router-link>
            </li>
            <li class="nav-item py-md-3">
              <router-link class="nav-link" to="/about" exact>ABOUT US</router-link>
            </li>
            <li class="nav-item py-md-3">
              <router-link class="nav-link" to="/blog" exact>NEWS</router-link>
            </li>
            <li class="nav-item py-md-3">
              <router-link class="nav-link" to="/contact" exact>CONTACT US</router-link>
            </li>
            <!-- <li class="nav-item py-md-3">
           
              <router-link class="nav-link" to="/" exact>SEARCH</router-link>
            </li>-->
          </ul>
        </div>
      </div>
    </nav>
    <!-- mobile -->
    <!-- mobile view -->
    <div class="header-mobile custom logo-center">
      <div class="konte-container-fluid">
        <div class="mobile-menu-hamburger" style="display:flex">
          <div class="site-branding">
            <router-link class to="/" style="color:#fff">
              <span>
                <img :src="starlogo" width="30px" />
              </span>
              SILVER STAR AUTO
            </router-link>
          </div>
        </div>
        <nav class="navbar navbar-expand-md navbar-light">
          <Slide right width="250" :closeOnNavigation="true" :crossIcon="true">
            <a id="home" href="#">
              <span>Home</span>
            </a>
            <div class="dropdown">
              <li
                class="dropdown-toggle"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style="font-weight:400"
              >BRANDS</li>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li class="dropdown-item">
                  <router-link class to="/mercedes/passenger" exact>PASSENGER VEHICLES</router-link>
                </li>
                <!-- <li class="dropdown-item">
                  <router-link class to="/mercedes/commercial" exact>COMMERCIAL VEHICLES</router-link>
                </li> -->
                <li class="dropdown-item">
                  <router-link class to="/peugeot" exact>PEUGEOT</router-link>
                </li>
                <li class="dropdown-item">
                  <router-link class to="/citroen" exact style="text-transform: uppercase;">Citroën</router-link>
                </li>
              </div>
            </div>
            <li class="py-md-3">
              <router-link class to="/aftersales" exact>AFTER-SALES</router-link>
            </li>
            <li class="py-md-3">
              <router-link class to="/about" exact>ABOUT US</router-link>
            </li>
            <li class="py-md-3">
              <router-link class to="/blog" exact>NEWS</router-link>
            </li>
            <li class="py-md-3">
              <router-link class to="/contact" exact>CONTACT US</router-link>
            </li>
          </Slide>
        </nav>

        <!-- <div class="mobile-header-icons">
          <div class="header-cart">
            <router-link class="nav-link" to="/wishlist" exact style="color:#666" id="cartHeader">
              <img :src="heart" alt="Wish" height="20px" />
              <span class="badge badge-success">{{ totalWishQuantity }}</span>
            </router-link>
            <router-link to class="nav-link" style="position:relative;color:#666" id="cartHeader">
              <img :src="basket" alt="Cart" height="20px" @click=" showcart" />
              <span class="badge badge-success">{{ totalCartQuantity }}</span>
            </router-link>
          </div>
        </div>-->
      </div>
    </div>
    <!-- dropdown -->
    <div class="branddropdown shadow">
      <div class="container">
        <div class="row">
          <div class="partnerslogo" style="margin-top:0rem !important">
            <div
              class="col-sm-6 col-md-4 col-lg-4"
              style=" border-right: 1px solid rgba(188, 188, 188, 0.3);padding: 2rem 2rem 2rem 0rem;"
            >
              <div class="partlogo" @click="passenger" style="cursor:pointer">
                <div class>
                  <div class="my-3">
                    <img class="car_logo" :src="UYU" width="90px" style="left:10%" />
                  </div>
                  <div class="icon_content">
                    <i class="el-icon-right"></i>

                    <h5>Mercedes-Benz</h5>
                    <p class="pass">Passenger Vehicles</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="col-sm-6 col-md-3 col-lg-3"
              style=" border-right: 1px solid rgba(188, 188, 188, 0.3);padding: 1.8rem 1.5rem;"
            >
              <div class="partlogo" @click="commercial" style="cursor:pointer">
                <div class>
                  <div class="my-3">
                    <img :src="UYU" width="90px" />
                  </div>
                  <div class="icon_content" style="right: 13%;">
                    <i class="el-icon-right"></i>

                    <h5>Mercedes-Benz</h5>
                    <p class="pass">Commercial Vehicles</p>
                  </div>
                </div>
              </div>
            </div> -->
            <div
              class="col-sm-6 col-md-4 col-lg-4"
              style=" border-right: 1px solid rgba(188, 188, 188, 0.3);padding: 1.8rem 1.5rem;"
            >
              <div class="partlogo" @click="pegeout" style="cursor:pointer">
                <div class>
                  <div class="my-3">
                    <img class="car_logo" :src="benz" width="62px" />
                  </div>
                  <div class="icon_content" style="right: 32%;">
                    <i class="el-icon-right"></i>
                    <!-- <p class="pass" style="color:#151515">hhhhh</p> -->
                    <h5>Peugeot</h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-6 col-md-4 col-lg-4"
              style=" border-right: 0px solid rgba(188, 188, 188, 0.3);padding: 2rem 0rem 2rem 2rem"
            >
              <div class="partlogo" @click="citreon" style="cursor:pointer">
                <div class>
                  <div class="my-3">
                    <img  class="car_logo" :src="cit" width="90px" />
                  </div>
                  <div class="icon_content" style="right: 32%;">
                    <i class="el-icon-right"></i>
                    <!-- <p class="pass" style="color:#151515">hhhhh</p> -->
                    <h5>Citroën</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var _ = require("lodash");

import axios from "axios";
import { Slide } from "vue-burger-menu";
var starlogo = require("../../assets/img/starlogo.png");
var cit = require("../../assets/img/Cit.png");
var benz = require("../../assets/img/benz.png");
var UYU = require("../../assets/img/UYU.png");

export default {
  name: "Header",
  components: { Slide },
  data() {
    return {
      starlogo,
      result: [],
      cit: cit,
      benz: benz,
      UYU: UYU,
      contactData: { message: "" }
    };
  },
  computed: {},
  methods: {
    citreon() {
      this.$router.push("/citroen");
    },
    commercial() {
      this.$router.push("/mercedes/commercial");
    },
    passenger() {
      this.$router.push("/mercedes/passenger");
    },
    pegeout() {
      this.$router.push("/peugeot");
    },
    brand() {
      // $(".branddropdown").css("display", "block");
      $(".branddropdown").toggle();
    },
    contactFormSubmitFxn(e) {
      var btn = e.currentTarget;
      var sve = document.querySelector(".s-v-e");
      if (sve) sve.remove();

      var contactFormData = {
        message: this.contactData.message
      };

      contactFormData = JSON.stringify(contactFormData);

      axios
        .post(APIURL + "search", contactFormData)
        .then(response => {
          var res = response.data;
          // btn.innerHTML = "Submit";

          var sent = window.localStorage.setItem(
            "apiData",
            JSON.stringify(response.data)
          );
          console.log(contactFormData);
          this.$router.push({ name: "searchresult" });

          //  router.push("/searchresult");

          if (res.status === true) {
            // this.contactData.message = "";

            this.$router.go(-1);
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {}
};
</script>

<style scoped>
</style>
